export const ColorCode = {
    green: "#008385",
    greenLight: "#00838540",
    greenDark: "#00838580",
    red: "#FF0000",
    white: "#FFFFFF",
    black: "#000000",
    grey: "#4a4a4a",
}
export const formatString =(input) => {
  return input
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
